import React, { HTMLAttributes } from 'react';
interface TitleProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  className?: string;
}

const PageTitle = ({ title, className }: TitleProps) => {
  return (
    <div
      data-testid="pageTitle-div"
      className={`hide md:show px-md sm:px-lg lg:px-3xl xl:px-4xl xl:pl-24 py-sm w-full flex flex-wrap text-[#677083] text-base bg-neutral-100 ${className}`}
    >
      {title}
    </div>
  );
};

export default PageTitle;
